import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/info.svg'


const _withScopeId = n => (_pushScopeId("data-v-67f6eed1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal full" }
const _hoisted_2 = { class: "p-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "squareButton bg_black" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      class: "infoIcon"
    })
  ])
], -1))
const _hoisted_4 = { class: "bg_black text-center py-3 px-5 my-4" }
const _hoisted_5 = { class: "listContainer" }
const _hoisted_6 = { class: "d-flex align-items-start mb-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs_18 red me-3" }, "1)", -1))
const _hoisted_8 = { class: "d-flex align-items-start mb-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs_18 red me-3" }, "2)", -1))
const _hoisted_10 = { class: "d-flex align-items-start mb-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs_18 red me-3" }, "3)", -1))
const _hoisted_12 = { class: "bg_black text-center py-3 px-2 my-4" }
const _hoisted_13 = { class: "d-flex align-items-center mb-4" }
const _hoisted_14 = { class: "d-flex align-items-center mb-4" }
const _hoisted_15 = { class: "d-flex align-items-center mb-4" }
const _hoisted_16 = { class: "d-flex align-items-center mb-4" }
const _hoisted_17 = { class: "d-flex align-items-center mb-4" }
const _hoisted_18 = { class: "d-flex align-items-center mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_localized_text, {
          localizedKey: "app_PERCHÉGIOCAREALLA#BEARACERCLUBALLSTARCHALLENGE?",
          text: "PERCHÉ GIOCARE ALLA #BEARACER CLUB ALL STAR CHALLENGE?",
          class: "fs_18 white d-block ln_21 text-uppercase"
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_localized_text, {
            localizedKey: "app_SeguiGliIndiziTrovaTutteLeSfide(QRCode)ERiscuotiLoSpecialeGiftAl#bearacerClubPoint",
            text: "Segui gli indizi, trova tutte le sfide (QR code) e riscuoti lo speciale gift al #bearacer club point",
            class: "fs_18 white d-block ln_21"
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_localized_text, {
            localizedKey: "app_AccumulaPuntiSuperandoLeSfideEScalaLaClassificaDellaChallenge",
            text: "Accumula punti superando le sfide e scala la classifica della Challenge.",
            class: "fs_18 white d-block ln_21"
          })
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_localized_text, {
            localizedKey: "app_Alle15:30IlRankingVerràCongelatoEIlPrimoClassificatoVerràChiamatoSulPalcoInsiemeAiCampioniMBMIdays!",
            text: "Alle 15:30 il ranking verrà congelato e il primo classificato verrà chiamato sul palco insieme ai campioni MBMIdays!",
            class: "fs_18 white d-block ln_21"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_localized_text, {
          localizedKey: "app_ComeSiAccumulanoIPunti?",
          text: "Come si accumulano i punti?",
          class: "fs_18 white d-block ln_21 text-uppercase"
        })
      ]),
      _createVNode(_component_localized_text, {
        localizedKey: "app_SuperandoIlMaggiorNumeroDiSfideRispondendoCorrettamenteAiQuizNelMinorTempoPossibile.<br/>IPuntiSonoAssegnatiComeNellaSprintRaceDellaMotoGP(oQuasi):",
        text: "Superando il maggior numero di sfide, rispondendo correttamente ai quiz nel minor tempo possibile.<br />I punti sono assegnati come nella Sprint Race della MotoGP (o quasi):",
        class: "fs_18 white d-block ln_21 mb-4"
      }),
      _createVNode(_component_localized_text, {
        localizedKey: "app_12Punti",
        text: "+12 Punti",
        class: "fs_18 red d-block ln_21"
      }),
      _createVNode(_component_localized_text, {
        localizedKey: "app_aChiRispondeCorrettamenteAUnQuizAl1°Tentativo",
        text: "a chi risponde correttamente a un quiz al 1° tentativo",
        class: "fs_18 white d-block ln_21 mb-4"
      }),
      _createVNode(_component_localized_text, {
        localizedKey: "app_9Punti",
        text: "+9 Punti",
        class: "fs_18 red d-block ln_21"
      }),
      _createVNode(_component_localized_text, {
        localizedKey: "app_aChiIndovinaAl2°Tentativo",
        text: "a chi indovina al 2° tentativo",
        class: "fs_18 white d-block ln_21 mb-4"
      }),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_localized_text, {
          localizedKey: "app_7Punti",
          text: "+7 Punti",
          class: "fs_18 red me-1"
        }),
        _createVNode(_component_localized_text, {
          localizedKey: "app_al3°Tentativo",
          text: "al 3° tentativo",
          class: "fs_18 white"
        })
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_localized_text, {
          localizedKey: "app_6Punti",
          text: "+6 Punti",
          class: "fs_18 red me-1"
        }),
        _createVNode(_component_localized_text, {
          localizedKey: "app_al4°Tentativo",
          text: "al 4° tentativo",
          class: "fs_18 white"
        })
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_localized_text, {
          localizedKey: "app_5Punti",
          text: "+5 Punti",
          class: "fs_18 red me-1"
        }),
        _createVNode(_component_localized_text, {
          localizedKey: "app_al5°Tentativo",
          text: "al 5° tentativo",
          class: "fs_18 white"
        })
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_localized_text, {
          localizedKey: "app_4Punti",
          text: "+4 Punti",
          class: "fs_18 red me-1"
        }),
        _createVNode(_component_localized_text, {
          localizedKey: "app_al6°Tentativo",
          text: "al 6° tentativo",
          class: "fs_18 white"
        })
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_localized_text, {
          localizedKey: "app_3Punti",
          text: "+3 Punti",
          class: "fs_18 red me-1"
        }),
        _createVNode(_component_localized_text, {
          localizedKey: "app_al7°Tentativo",
          text: "al 7° tentativo",
          class: "fs_18 white"
        })
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_localized_text, {
          localizedKey: "app_2Punti",
          text: "+2 Punti",
          class: "fs_18 red me-1"
        }),
        _createVNode(_component_localized_text, {
          localizedKey: "app_al8°Tentativo",
          text: "al 8° tentativo",
          class: "fs_18 white"
        })
      ]),
      _createVNode(_component_localized_text, {
        localizedKey: "app_1Punto",
        text: "+1 Punto",
        class: "fs_18 red d-block ln_21"
      }),
      _createVNode(_component_localized_text, {
        localizedKey: "app_aChiImpiegaPiùDi8TentativiPerRispondereCorrettamente",
        text: "a chi impiega più di 8 tentativi per rispondere correttamente.",
        class: "fs_18 white d-block ln_21 mb-4"
      }),
      _createVNode(_component_localized_text, {
        localizedKey: "app_IlTempoSaràDeterminantePerLaClassificaSoloInCondizioneDiParitàDiPunteggio.<br/><br/>SaraiTuLaProssima#bearacerClubAllStar?",
        text: "Il tempo sarà determinante per la classifica solo in condizione di parità di punteggio.<br /><br />Sarai tu la prossima #bearacer club All Star?",
        class: "fs_18 white d-block ln_21 mb-4"
      }),
      _createElementVNode("button", {
        class: "secondaryButton w-100 mt-4",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "app_Ok",
          text: "Ok"
        })
      ])
    ])
  ]))
}